/**
 * 头部导航组件
 * zxw
 * 2024-05-25
 */
import { Header } from "antd/es/layout/layout";
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    QuestionOutlined,
    ExportOutlined,
    SettingOutlined,
} from "@ant-design/icons";
import { Row, Col, Dropdown,Avatar,Button, message} from "antd";
import cookie from "react-cookies";
import CNF from "../../incs/Config";
import { DeleteCookies } from "../../incs/FunHelper";
import SYIcon from './SYIcon';

const onClick = (e) =>{
    if(e.key === "1"){
        window.location.href = CNF.userUrl;
    }
    if(e.key === "2"){
        message.info("正在努力开发中......");
    }
    if(e.key === "3"){
        // 退出登录
        DeleteCookies()
    }
}

const items = [
    {
        key: "1",
        label: "设置",
        icon: <SettingOutlined />
    },
    {
        key: "2",
        label: "帮助",
        icon: <QuestionOutlined />
    },{
        key: "3",
        label: "退出",
        icon: <ExportOutlined />
    }
]

const SYHeader = (props) => {
    return <Header style={{ background: "#FFFFFF", padding:"0" }}>
        <Row>
            <Col span={1}>
                {props.collapsed?<MenuUnfoldOutlined onClick={props.setCollapsed}/>: <MenuFoldOutlined onClick={props.setCollapsed}/>}
            </Col>
            <Col span={23}>
                <Row justify="end">
                    {
                        props.navLists.length && props.navLists.map((item) =>{
                            return <Col key={item.name} span={1}><a href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a></Col>
                        })
                    }
                    <Col span={2}> <SYIcon policy={props.policy}/></Col>
                    <Col span={2}><Button type="link" style={{ color:"#6C6C6C" }} onClick={(e) => {
                        e.preventDefault();
                    }}>简体中文</Button></Col>
                    <Col span={1}>
                        <Dropdown menu={{ items, onClick}}>
                            <Avatar 
                                style={{ 
                                    cursor: "pointer",
                                    color: "#FFFFFF", 
                                    verticalAlign: "middle",
                                    backgroundColor: "#FF904D" }} 
                                size="middle"
                            >
                                {cookie.load(CNF.cookies.keyId)?cookie.load(CNF.cookies.keyId).substr(0,1).toUpperCase():'U'}
                            </Avatar>
                        </Dropdown>
                    </Col>
                </Row>
            </Col>
        </Row>
    </Header>
}

export default SYHeader